const checkinConditionsFunctions = require('./checkin_conditions');
const isRedirectionFromConfirmation = require('od-modules/xsell/utils').isRedirectionFromConfirmation;
const websiteConfigCollection = require('od-modules/collections/website.collection').getInstance();
const checkinRepository = require('./checkin_repository');

const BOOKING_INFO = 'bookingInfo';

const getBooking = () => Odigeo.Utils.parseJson(Odigeo.Session.get(BOOKING_INFO)) || {};

const isEnabledInDesktop = (alias) => alias && Odigeo.Utils.isDesktop();

const isEnabledInMobile = (alias) => alias && Odigeo.Utils.isMobile();

const isEnabled = ({desktopAlias, mobileAlias}) =>
    isEnabledInDesktop(desktopAlias) || isEnabledInMobile(mobileAlias);

const isRefundInProgressEnabled = async(bookingId) => {
    return websiteConfigCollection.forceLoad().then(() => {
        const {
            statusPaidCheckinConfirmationDesktop = false,
            statusPaidCheckinConfirmationMobile = false,
            statusPaidCheckinNoConfirmationDesktop = false,
            statusPaidCheckinNoConfirmationMobile = false,
        } = websiteConfigCollection.getAB() || {};

        const enabledInConfirmation = isRedirectionFromConfirmation(bookingId) && isEnabled({
            desktopAlias: statusPaidCheckinConfirmationDesktop,
            mobileAlias: statusPaidCheckinConfirmationMobile,
        });

        const enabledInMyTrips = !isRedirectionFromConfirmation(bookingId) && isEnabled({
            desktopAlias: statusPaidCheckinNoConfirmationDesktop,
            mobileAlias: statusPaidCheckinNoConfirmationMobile,
        });

        return enabledInConfirmation || enabledInMyTrips;
    });
};

const isRefundInProgress = async() => {
    const {bookingBasicInfo = {}, checkinConditions = {}} = getBooking();
    const {id} = bookingBasicInfo;
    const isAutoCheckinProduct = !!checkinConditionsFunctions.isAutoCheckinProduct(checkinConditions);
    const isEnabled = await isRefundInProgressEnabled(id);
    const repository = checkinRepository.factory(Odigeo.Settings.getProperty('serviceUsersFormatter'));
    const checkinStatus = await repository.getCheckinStatus(bookingBasicInfo.id);
    const hasErrors = checkinConditionsFunctions.isRequestedCheckinWithErrors(checkinStatus);
    return hasErrors && isAutoCheckinProduct && isEnabled;
};

module.exports = {
    BOOKING_INFO,
    isRefundInProgress,
};
